import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent {

  public dataListing:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public CurrentUrl:any=this.router.url;
  public Ids:any='';
  public reasons:any='';
  public statuskey:any='';

  
  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('hva_login') || "{}");  
    this.getDetail(this.p);
   }

  ngOnInit(): void {
  }

     getDetail(page:any){
      this.dataListing=[];
      this.loading=true;
      var url="users?page="+page;
      if(this.searchKey!=''){
        url=url+'&search='+this.searchKey;
      }
      if(this.statuskey!=''){
        url=url+'&status='+this.statuskey;
      }
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {  
          var self=this;
          response.data.filter((el:any)=>{
            if(el.image ==''){
              el.image =self.service.defaultImage;
            }
          })        
          this.dataListing=response.data ;
          this.totalCount = response.totalCounts;  
          this.loading=false;
        } else {
          this.dataListing=[];
          this.totalCount =  response.totalCounts;  
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }

   
    redirect(item:any,type:any){
      this.Ids =item._id;
      localStorage.setItem('hva_content',JSON.stringify(item));
      if(type ==4){
        this.verifyAccount();
      }else if(type ==1){        
        this.router.navigate(['/user-detail']);
      } else if (type ==3){
        if(this.CurrentUrl =='/service-provider-listing'){
          this.router.navigate(['/service-provider-edit']);
        } else {
          this.router.navigate(['/user-edit']);
        }  
      } else {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        }).then((result:any) => {
          let statusType: number = 0;
          if (result.isConfirmed) {
            $('#text3').trigger('click');

          }
        });
      }
    }
  
    delete(){
      if(this.reasons==''){
        this.service.dangerAlert('Please give reason');
        return;
      } else {
        var detail={
          "reason": this.reasons
        }
        var url='/user-delete/'+ this.Ids; 
        this.service.updateApi1(detail,url).subscribe(((response:any)=>{
          if(response.success==1) {  
            this.reasons='';
            $('#cclosebtn').trigger('click');
            this.loading=false;
            this.p=1;
            this.getDetail(this.p);
          } else {
            this.loading=false;
          }
        }), (error) => { this.loading =false; });
      }
   
    }

    verifyAccount(){
      this.loading=true;
      var url='/user-status-update/'+this.Ids;
      this.service.updateApi1({},url).subscribe(((response:any)=>{
        if(response.success==1){
          this.service.successAlert(response.message);
          this.getDetail(this.p);
          this.loading=false;
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }))
    }

    reset(){
      this.p=1;
      this.searchKey='';
      this.statuskey='';
      this.getDetail(this.p);
    }

}
